import { DOCUMENT } from "@angular/common";
import { Directive, ElementRef, Inject, Output, EventEmitter } from "@angular/core";
import { fromEvent } from "rxjs";
import { distinctUntilChanged, map, switchMap, takeUntil, tap } from "rxjs/operators";

@Directive({
  selector: "[resizable]"
})
export class ResizableDirective {
  @Output()
  readonly resizable = new EventEmitter<number>();

  constructor(
    @Inject(DOCUMENT) private readonly documentRef: Document,
    private readonly elementRef: ElementRef<HTMLElement>
  ) {
    fromEvent<MouseEvent>(this.elementRef.nativeElement, "mousedown").pipe(
      tap(e => e.preventDefault()),
      switchMap((startEvent) => {
        const th = this.elementRef.nativeElement.closest("th")!;
        const { width, right } = th.getBoundingClientRect();
        const startX = startEvent.pageX;
        const scrollLeft = th.closest("table")!.parentElement!.scrollLeft;

        return fromEvent<MouseEvent>(this.documentRef, "mousemove").pipe(
          map(({ pageX }) => width + pageX - startX + (scrollLeft - th.closest("table")!.parentElement!.scrollLeft)),
          distinctUntilChanged(),
          takeUntil(fromEvent(this.documentRef, "mouseup"))
        );
      })
    ).subscribe(width => this.resizable.emit(width));
  }
}
